import type { PathDictGenericItem, PathDictNodeItem } from "@/libs/models/path";

/**
 * Generate a link ID from the IDs of its source and target nodes.
 */
export const generateLinkIDFromNodes = (
  source: PathDictNodeItem["id"],
  target: PathDictNodeItem["id"],
) => {
  return `${source}_${target}`;
};

/**
 * Given a list of features, if the first one is a node, and all others are links
 * return the node. Else, return the list unaffected
 */
export const prioritizeNodeSelectionOverLinks = (
  features: PathDictGenericItem[],
) => {
  if (features.length == 0) return features;
  if (features.at(0).type != "node") return features;
  // If all features beside the first one are of type link, return list with only first item
  if (
    features.slice(1).every((feature) => feature.type === "link") &&
    !features.every((feature) => feature.type === "node")
  ) {
    return [features.at(0)];
  }
  // Otherwise, return list with all items
  return features;
};
